import { memo } from 'react';

import type { Enum, NomineeType } from '../../types';

import DetailedScore from './DetailedScore';
import SummaryScore from './SummaryScore';

export const ScoreFormat = {
  Detailed: 'Detailed', // TeamA 2 - 1 TeamB
  Summary: 'Summary', // Won 2 - 1 vs TeamB
};
export type ScoreFormat = Enum<typeof ScoreFormat>;

export const MatchInfo = ({
  nominee,
  scoreFormat = ScoreFormat.Detailed,
}: {
  nominee: NomineeType;
  scoreFormat?: ScoreFormat;
}) => {
  if (scoreFormat === ScoreFormat.Summary) {
    return <SummaryScore nominee={nominee} />;
  }

  return <DetailedScore nominee={nominee} />;
};
export default memo(MatchInfo);
